import { useDriversQuery } from "@evr/apis/driver";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectDriversQuery } from "@evr/store/slices/driver";

export const useGetDriversQuery = () => {
  const queryParams = useAppSelector(selectDriversQuery);
  return useDriversQuery(queryParams);
};
